import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import GlobalThemeProvider from "styles/GlobalThemeProvider";
import { Provider } from "react-redux";
import store from "redux/configureStore";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode> // 페이지들이 두번씩 render되는 문제가 있어 주석처리합니다.
    <Provider store={store}>
      <BrowserRouter>
        <GlobalThemeProvider>
          <App />
        </GlobalThemeProvider>
      </BrowserRouter>
    </Provider>
  // </React.StrictMode>,
);
